import Vue from 'vue'
import Router from 'vue-router'
import EventBus from '../plugins/event-bus'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', name: 'home', component: () => import('@/components/Frontpage') },
    { path: '/news/:id', name: 'news-page', meta: {type: 'news'}, component: () => import('@/components/ContentPage') },
    { path: '/:type/:id', name: 'content-page', component: () => import('@/components/ContentPage') },
    { path: '*', name: 'not-found', component: () => import('@/components/NotFound') }
  ]
})

router.beforeEach((to, from, next) => {
  EventBus.$emit('set-media-elements', [])
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js